import { Injectable, Injector } from '@angular/core';
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Adal5Service } from 'adal-angular5';
import { Router } from '@angular/router';
import { LoggerService } from '../logger/global-logger.service';

import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ExtendedHttpService extends Http {
  private router;
  constructor(backend: XHRBackend, defaultOptions: RequestOptions,
    private injector: Injector, public auth: Adal5Service, private logger: LoggerService) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (typeof url === 'string') {
      if (!options) {
        options = { headers: new Headers() };
      }
      this.setHeaders(options);
    } else {
      this.setHeaders(url);
    }
    return super.request(url, options).do(this.handleResponse()).catch(this.catchErrors());
  }

  private catchErrors() {
    return (res: Response) => {
      if (this.router == null) {
        this.router = this.injector.get(Router);
      }
      if (res) {
         this.handleErrors(res.status);
      }
      return Observable.throw(res);
    };
  }
  private handleResponse() {
    return (res: Response) => {
      if (res) {
       // this.handleErrors(res.json()['status']);
      }
      return Observable.of(res);
    };
  }

  private setHeaders(objectToSetHeadersTo: Request | RequestOptionsArgs) {
    if (this.auth.userInfo.authenticated) {
      objectToSetHeadersTo.headers.set('Authorization', `Bearer ${this.auth.userInfo.token}`);
    } else {
      this.router.navigate(['/login']);
    }
  }
  private handleErrors(status: any) {
    switch ( status) {
      case 401:
          // Authentication Expired Redirecting to login
        // console.log('Error_Token_Expired: redirecting to login.');
       // this.router.navigate(['/login']);
       this.showToaster('error', 'Your session has expired. Please refresh to continue.');
        break;
      // case 403:
      //   this.showToaster('error', 'User is not authorized');
      //   break;
      // case 404:
      //   this.showToaster('error', 'No Record Found');
      //   break;
      // case 400:
      //   this.showToaster('error', 'Bad Request');
      //   break;
      // case 412:
      //   this.showToaster('error', 'This case id does not exists');
      //   break;
      // case 409:
      //   this.showToaster('error', 'Duplicate issue');
      //   break;
      // case 406:
      //   this.showToaster('error', 'Upload limit exceeeded');
      //   break;
      // case 500:
      //   this.showToaster('error', 'Something went wrong');
      //   break;
      // case 204:
      //   this.showToaster('error', 'No Record Found');
      //   break;
    }
  }
  private showToaster(type: string, msg: string) {
    if (type === 'success') {
      this.logger.success({ message: msg }, true, false);
    } else {
      this.logger.warning({ message: msg }, true, false);
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/core/auth/extended-http.service.ts